export default {"src":"/_next/static/media/me.984b2f66.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};